import $axios from '@/api/apiAcc';

const getMonitoringDetails = async id => {
  const response = await $axios.get(`/api/monitoring/?id=${id}`);
  return response;
};

export default {
  getMonitoringDetails,
};
